const EN = 'en-US' // English
const ES = 'es-ES' // spanish
const PT = 'pt-BR' // Portuguese
const ZH = 'zh-Hans' // Chinese (Simplified)
const VI = 'vi-VI' // Vietnamese
const HI = 'cy-HT' // Haitian Creole

export function getTransLang (lang) {
  switch (lang) {
    case EN:
      return {
        dashboard: 'Dashboard',
        myInfo: 'My Info',
        myBenefits: 'My Benefits',
        myDocuments: 'My Documents',
        myNotices: 'My Notices',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: 'No Renewal due at this time',
        daystoComplete: 'Days to Complete Annual Renewal',
        daysAgoExpire: 'Days ago Renewal Expired',
        requestForInfo: 'Request For Information',
        massFormsCompleted: 'MassHealth Forms to be completed',
        alertsTitle2: 'Days to Complete Annual Renewal',
        application: 'Application',
        submitApplication: 'Submit an Application',
        submitApplicationDetails: 'You can apply online, by phone, by mail or in person.',
        verification: 'Verification',
        sendVerification: 'Send in Verification and Enroll',
        sendVerificationDetails: 'You may need to send in documentation to start your benefits. You may also need to enroll in a health plan.',
        benefits: 'Benefits',
        getHealthBenefits: 'Get Health Benefits',
        getHealthBenefitsDesc: 'This should take about 20 minutes.',
        for: 'For',
        Processed: 'Processed',
        Unprocessed: 'Unprocessed',
        processedDate: 'Processed Date',
        first_name: 'First name',
        last_name: 'Last name',
        date_of_birth: 'Date of birth',
        email: 'Email',
        emailAddress: 'Email address',
        logIn: 'Log In',
        received: 'received on',
        mhaLinkedC1: 'View your current MassHealth/Health Connector eligibility and MassHealth enrollment information, documents and MassHealth notices.',
        mhaLinkedC2: 'Need more info?',
        mhaNotLinkedBtnContent: 'Connect to my MassHealth info',
        mhaNotLinkedC1: 'Already receiving health benefits? Tell us little more about yourself, and we will show your existing benefits.',
        mhaNotLinkedC2: 'Not receiving health benefits?',
        mhaLinkedBtnContent: 'View my health info',
        dtaLinkedC1: 'View and manage your SNAP/cash benefits, submit interim report/recertification and documents online.',
        dtaLinkedC2: 'Need more info?',
        dtaLinkedBtnContent: 'Go to DTAConnect.com',
        dtaNotLinkedC1: 'Already receiving SNAP/cash benefits? Tell us little more about yourself, and we will show your existing benefits.',
        dtaNotLinkedC2: 'Not receiving SNAP/cash benefits?',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: 'Date is required.',
        monthRequired: 'Month is required.',
        yearRequired: 'Year is required.',

        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: 'SSN is required.',
        MHIDRequired: 'MHID is required.',
        invalidMHID: 'Invalid MHID.',
        dob: 'DOB',
        invalidDOB: 'Please enter a valid date of birth'

      }
    case ES:
      return {
        dashboard: 'Tablero',
        myInfo: 'Mi información',
        myBenefits: 'Mis beneficios',
        myDocuments: 'Mis documentos',
        myNotices: 'Mis avisos',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: 'En este momento no hay ninguna Renovación vencida',
        daystoComplete: 'Días para completar la Renovación anual',
        daysAgoExpire: 'Días desde que venció la renovación',
        requestForInfo: 'Solicitud de información',
        massFormsCompleted: 'Formularios de MassHealth para completar',
        alertsTitle2: 'Días para completar la Renovación anual',
        application: 'Application',
        submitApplication: 'Presentar una solicitud',
        submitApplicationDetails: 'Puede solicitar en línea, por teléfono, por correo postal o en persona.',
        verification: 'Verification',
        sendVerification: 'Envíe las verificaciones para inscribirse',
        sendVerificationDetails: 'Es posible que deba enviar documentación para iniciar sus beneficios. También es posible que deba inscribirse en un plan de seguro de salud.',
        benefits: 'Benefits',
        getHealthBenefits: 'Obtenga beneficios de salud',
        getHealthBenefitsDesc: 'Debería llevarle unos 20 minutos.',
        for: 'Para',
        Processed: 'Procesado',
        Unprocessed: 'Sin procesar',
        processedDate: 'Fecha de procesamiento',
        first_name: 'Nombre',
        last_name: 'Apellido',
        date_of_birth: 'Fecha de nacimiento',
        email: 'Correo electrónico',
        emailAddress: 'Dirección de correo electrónico',
        logIn: 'Iniciar sesión',
        received: 'recibido el',
        mhaLinkedC1: 'Vea sus datos actuales de elegibilidad de MassHealth o Health Connector y la información de inscripción de MassHealth, sus documentos y sus avisos de MassHealth.',
        mhaLinkedC2: '¿Necesita más información?',
        mhaNotLinkedBtnContent: 'Conectar con mi información de MassHealth',
        mhaNotLinkedC1: '¿Ya está recibiendo beneficios de salud? Denos más datos sobre usted y le mostraremos la información sobre sus beneficios actuales.',
        mhaNotLinkedC2: '¿No recibe beneficios de salud?',
        mhaLinkedBtnContent: 'Ver mi información de salud',
        dtaLinkedC1: 'Vea y administre sus beneficios en efectivo o de SNAP, presente el informe provisorio o la recertificación y otros documentos en línea.',
        dtaLinkedC2: '¿Necesita más información?',
        dtaLinkedBtnContent: 'Visite DTAConnect.com',
        dtaNotLinkedC1: '¿Ya está recibiendo beneficios en efectivo o SNAP? Denos más datos sobre usted y le mostraremos la información sobre sus beneficios actuales.',
        dtaNotLinkedC2: '¿No recibe beneficios en efectivo o SNAP?',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: 'La fecha es obligatoria.',
        monthRequired: 'El mes es obligatorio.',
        yearRequired: 'El año es obligatorio.',

        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: 'El SSN es obligatorio.',
        MHIDRequired: 'La identificación (ID) de MH es obligatoria.',
        invalidMHID: 'MHID inválida.',
        dob: 'fecha de nacimiento',
        invalidDOB: 'Please enter a valid date of birth'
      }
    case PT:
      return {
        dashboard: 'Painel',
        myInfo: 'Meus dados',
        myBenefits: 'Meus benefícios',
        myDocuments: 'Meus documentos',
        myNotices: 'Meus avisos',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: 'Nenhuma renovação vencida neste momento',
        daystoComplete: 'Dias para concluir a renovação anual',
        daysAgoExpire: 'Dias atrás, sua renovação venceu',
        requestForInfo: 'Solicitação de informações',
        massFormsCompleted: 'Formulários do MassHealth para preencher',
        alertsTitle2: 'Dias para concluir a renovação anual',
        application: 'Application',
        submitApplication: 'Fazer inscrição',
        submitApplicationDetails: 'Você pode se cadastrar online, por telefone, por correio ou pessoalmente.',
        verification: 'Verification',
        sendVerification: 'Enviar verificação e inscrever-se',
        sendVerificationDetails: 'Pode ser necessário enviar documentação para iniciar os benefícios. Você também pode precisar se inscrever em um plano de saúde.',
        benefits: 'Benefits',
        getHealthBenefits: 'Receba os benefícios de saúde',
        getHealthBenefitsDesc: 'O processo leva cerca de 20 minutos.',
        for: 'Para',
        Processed: 'Processado',
        Unprocessed: 'Não processado',
        processedDate: 'Data de processamento',
        first_name: 'Nome',
        last_name: 'Sobrenome',
        date_of_birth: 'Data de nascimento',
        email: 'E-mail',
        emailAddress: 'Endereço de e-mail',
        logIn: 'Entrar',
        received: 'recebido no dia',
        mhaLinkedC1: 'Acesse informações atualizadas sobre sua elegibilidade ao MassHealth ou Health Connector, bem como informações de inscrição, documentação e avisos do MassHealth.',
        mhaLinkedC2: 'Precisa de outras informações?',
        mhaNotLinkedBtnContent: 'Conectar aos meus dados do MassHealth ',
        mhaNotLinkedC1: 'Já recebe benefícios de saúde? Conte um pouco mais sobre você e exibiremos os seus benefícios atuais.',
        mhaNotLinkedC2: 'Você não recebe benefícios de saúde?',
        mhaLinkedBtnContent: 'Visualizar meus dados de saúde',
        dtaLinkedC1: 'Visualize e gerencie online os seus benefícios SNAP/monetários, envie relatórios ou recertificações provisórias e documentos.',
        dtaLinkedC2: 'Precisa de outras informações?',
        dtaLinkedBtnContent: 'Acesse DTAConnect.com',
        dtaNotLinkedC1: 'Você já recebe os benefícios SNAP/monetários? Conte um pouco mais sobre você e exibiremos os seus benefícios atuais..',
        dtaNotLinkedC2: 'Você não recebe os benefícios SNAP/monetários?',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: 'Data é um campo obrigatório.',
        monthRequired: 'Mês é um campo obrigatório.',
        yearRequired: 'Ano é um campo obrigatório.',

        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: 'Número de segurança social (SSN) é um campo obrigatório.',
        MHIDRequired: 'Número de identificação do MassHealth é um campo obrigatório.',
        invalidMHID: 'MHID inválido.',
        dob: 'data de nascimento',
        invalidDOB: 'Please enter a valid date of birth'
      }
    case ZH:
      return {
        dashboard: '儀表板',
        myInfo: '我的資訊',
        myBenefits: '我的福利',
        myDocuments: '我的文件',
        myNotices: '我的通知',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: '目前沒有到期的續延',
        daystoComplete: '完成年度續保的天數',
        daysAgoExpire: '____天前續延逾期',
        requestForInfo: '索取資訊',
        massFormsCompleted: '需要填寫的MassHealth表格',
        alertsTitle2: '完成年度續保的天數',
        application: 'Application',
        submitApplication: '提交申請',
        submitApplicationDetails: '您可以在網上或打電話填寫申請表，或郵寄或親自遞送申請表。',
        verification: 'Verification',
        sendVerification: '發送驗證和註冊資訊',
        sendVerificationDetails: '您可能需要提交證明文件才能開始領取福利。您可能還需要註冊參加一項保健計劃。',
        benefits: 'Benefits',
        getHealthBenefits: '獲得保健福利',
        getHealthBenefitsDesc: '這大約需要20分鐘。',
        for: '對於',
        Processed: '處理',
        Unprocessed: '未處理',
        processedDate: '處理日期',
        first_name: '名',
        last_name: '姓',
        date_of_birth: '出生日期',
        email: '電子郵件',
        emailAddress: '電子郵件地址',
        logIn: '登錄',
        received: '已於收到',
        mhaLinkedC1: '查看您當前的MassHealth/Health Connector資格和MassHealth註冊資訊、文件和MassHealth通知。',
        mhaLinkedC2: '需要更多資訊嗎？',
        mhaNotLinkedBtnContent: '連接到我的 MassHealth 資訊 ',
        mhaNotLinkedC1: '已經在享受保健福利？請告訴我們更多關於您自己的資訊，我們將顯示您現有的福利。',
        mhaNotLinkedC2: '不在領取保健福利？',
        mhaLinkedBtnContent: '查看我的健康資訊',
        dtaLinkedC1: '查看並管理您的 SNAP/現金福利，在線上提交中期報告書、重新認證書以及文件。',
        dtaLinkedC2: '需要更多資訊嗎？',
        dtaLinkedBtnContent: '前往 DTAConnect.com',
        dtaNotLinkedC1: '已在接受 SNAP/現金福利嗎？請告訴我們更多關於您自己的資訊，我們將顯示您現有的福利。',
        dtaNotLinkedC2: '不在領取SNAP/現金福利？',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: '日期為必填項。',
        monthRequired: '月份為必填項。',
        yearRequired: '年份為必填項。',

        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: '要求提供社會安全代碼（SSN）.',
        MHIDRequired: '要求提供MassHealth身份代碼（MHID）.',
        invalidMHID: '無效MHID.',
        dob: '出生日期',
        invalidDOB: 'Please enter a valid date of birth'
      }
    case VI:
      return {
        dashboard: 'Trang tổng quan',
        myInfo: 'Thông tin của tôi',
        myBenefits: 'Phúc lợi của tôi',
        myDocuments: 'Giấy tờ của tôi',
        myNotices: 'Các Thông báo',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: 'Không có đơn đăng ký lại nào đến hạn tại thời điểm này',
        daystoComplete: 'Số ngày để Hoàn thành Gia hạn Hằng năm',
        daysAgoExpire: 'Ngày từ khi đơn đăng ký lại của quý vị Hết hạn',
        requestForInfo: 'Yêu cầu Thông tin',
        massFormsCompleted: 'Các Biểu mẫu MassHealth cần điền',
        alertsTitle2: 'Số ngày để Hoàn thành Gia hạn Hằng năm',
        application: 'Application',
        submitApplication: 'Gửi đơn xin',
        submitApplicationDetails: 'Quý vị có thể nộp đơn trực tuyến, qua điện thoại, qua thư, hoặc trực tiếp.',
        verification: 'Verification',
        sendVerification: 'Gửi Giấy tờ Xác minh và Đăng ký Tham gia',
        sendVerificationDetails: 'Quý vị có thể cần nộp giấy tờ để bắt đầu nhận phúc lợi. Quý vị cũng có thể phải đăng ký tham gia vào một chương trình bảo hiểm sức khỏe.',
        benefits: 'Benefits',
        getHealthBenefits: 'Nhận Phúc lợi Sức khỏe',
        getHealthBenefitsDesc: 'Đơn này sẽ mất khoảng 20 phút.',
        for: 'Đã nhận được tài liệu của',
        Processed: 'Đã xử lý',
        Unprocessed: 'Chưa xử lý',
        processedDate: 'Ngày đã xử lý',
        first_name: 'Tên',
        last_name: 'Họ',
        date_of_birth: 'Ngày sinh',
        email: 'Email',
        emailAddress: 'Địa chỉ email',
        logIn: 'Đăng nhập',
        received: 'vào ngày',
        mhaLinkedC1: 'Xem thông tin điều kiện cho MassHealth/Health Connector và thông tin đăng ký MassHealth của quý vị, tài liệu và thông báo của MassHealth.',
        mhaLinkedC2: 'Quý vị cần thêm thông tin?',
        mhaNotLinkedBtnContent: 'Kết nối với thông tin MassHealth',
        mhaNotLinkedC1: 'Quý vị đã nhận phúc lợi y tế? Hãy cho chúng tôi biết thêm thông tin về quý vị và chúng tôi sẽ hiển thị cho thấy phúc lợi hiện có của quý vị.',
        mhaNotLinkedC2: 'Quý vị không có nhận bảo hiểm y tế?',
        mhaLinkedBtnContent: 'Xem thông tin sức khỏe của tôi',
        dtaLinkedC1: 'Xem và quản lý phúc lợi SNAP/tiền mặt, nộp trực tuyến báo cáo/đơn chứng nhận lại tạm thời và tài liệu.',
        dtaLinkedC2: 'Quý vị cần thêm thông tin?',
        dtaLinkedBtnContent: 'Đi đến DTAConnect.com',
        dtaNotLinkedC1: 'Quý vị đang nhận phúc lợi SNAP/tiền mặt? Hãy cho chúng tôi biết thêm thông tin về quý vị và chúng tôi sẽ hiển thị cho thấy phúc lợi hiện có của quý vị.',
        dtaNotLinkedC2: 'Quý vị không có nhận trợ cấp SNAP/tiền mặt?',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: 'Bắt buộc phải có ngày.',
        monthRequired: 'Bắt buộc phải có tháng.',
        yearRequired: 'Bắt buộc phải có năm.',

        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: 'Bắt buộc phải có SSN.',
        MHIDRequired: 'Bắt buộc phải có MHID.',
        invalidMHID: 'Số MHID không hợp lệ.',
        dob: 'Ngày sinh',
        invalidDOB: 'Please enter a valid date of birth'
      }
    case HI:
      return {
        dashboard: 'Tablo bò',
        myInfo: 'Enfòmasyon mwen',
        myBenefits: 'Benefis mwen yo',
        myDocuments: 'Dokiman mwen yo',
        myNotices: 'Avi mwen yo',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: 'Pa gen renouvèlman pou kounye a',
        daystoComplete: 'Jou pou konplete renouvèlman anyèl',
        daysAgoExpire: 'Jou depi renouvèlman an ekspire',
        requestForInfo: 'Demann pou enfòmasyon',
        massFormsCompleted: 'Fòm MassHealth ki dwe ranpli',
        alertsTitle2: 'Jou pou konplete renouvèlman anyèl',
        application: 'Application',
        submitApplication: 'Soumèt yon aplikasyon',
        submitApplicationDetails: 'Ou kapab aplike sou entènèt, pa telefòn, pa lapòs oswa an pèson.',
        verification: 'Verification',
        sendVerification: 'Voye Verifikasyon epi enskri',
        sendVerificationDetails: 'Ou kapab bezwen voye dokimantasyon pou kòmanse benefis ou. Ou kapab bezwen tou pou anwole nan plan sante. ',
        benefits: 'Benefits',
        getHealthBenefits: 'Pran benefis sante',
        getHealthBenefitsDesc: 'Sa ap pran apeprè 20 minit.',
        for: 'Pou',
        Processed: 'Trete',
        Unprocessed: 'Pa trete',
        processedDate: 'Dat li trete',
        first_name: 'Premye non',
        last_name: 'Siyati',
        date_of_birth: 'Dat Nesans',
        email: 'Imèl',
        emailAddress: 'Adrès imel',
        logIn: 'Siyen',
        received: 'resevwa sou',
        mhaLinkedC1: 'Wè enfòmasyon aktyèl ou sou admisiblite nan MassHealth/Health Connector e enfòmasyon sou enskripsyon e dokiman ou yo nan MassHealth, epi avi MassHealth yo.',
        mhaLinkedC2: 'Eske w bezwen plis enfòmasyon?',
        mhaNotLinkedBtnContent: 'Konekte sou enfòmasyon MassHealth mwen',
        mhaNotLinkedC1: 'Ou deja ap resevwa benefis sante? Ban n yon ti enfòmasyon sou ou, epi n ap montre w benefis ou genyen.',
        mhaNotLinkedC2: 'Byenvini nan benefis Massachusetts',
        mhaLinkedBtnContent: 'Gade enfòmasyon sante mwen',
        dtaLinkedC1: 'Gade epi jere SNAP ou/benefis kash, soumèt yon rapò pwovizwa/resètifikasyon ak dokiman sou entènèt.',
        dtaLinkedC2: 'Eske w bezwen plis enfòmasyon?',
        dtaLinkedBtnContent: 'Ale sou DTAConnect.com',
        dtaNotLinkedC1: 'Deja ap resevwa SNAP/benefis kash? Ban n yon ti enfòmasyon sou ou, epi n ap montre w benefis ou genyen.',
        dtaNotLinkedC2: 'Èske w pap resevwa benefis kach oswa SNAP?',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: 'Dat la obligatwa.',
        monthRequired: 'Mwa a obligatwa.',
        yearRequired: 'Ane a obligatwa.',

        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: 'SSN obligatwa.',
        MHIDRequired: 'MHID obligatwa.',
        invalidMHID: 'MHID a pa valab.',
        dob: 'Dat nesans',
        invalidDOB: 'Please enter a valid date of birth'
      }
    default:
      return {
        dashboard: 'Dashboard',
        myInfo: 'My Information',
        myBenefits: 'My Benefits',
        myDocuments: 'My Documents',
        myNotices: 'My Notices',
        useraccess: 'Restrict/Unrestrict Access',
        manageBanners: 'Manage Banners',
        noRenewel: 'No Renewal due at this time',
        daystoComplete: 'Days to Complete Annual Renewal',
        daysAgoExpire: 'Days ago Renewal Expired.',
        requestForInfo: 'Request For Information',
        massFormsCompleted: 'MassHealth Forms to be completed',
        alertsTitle2: 'Days to Complete Annual Renewal',
        application: 'Application',
        submitApplication: 'Submit an Application',
        submitApplicationDetails: 'You can apply online, by phone, by mail or in person.',
        verification: 'Verification',
        sendVerification: 'Send in Verification and Enroll',
        sendVerificationDetails: 'You may need to send in documentation to start your benefits. You may also need to enroll in a health plan.',
        benefits: 'Benefits',
        getHealthBenefits: 'Get Health Benefits',
        getHealthBenefitsDesc: 'This should take about 20 minutes.',
        for: 'For',
        Processed: 'Processed',
        Unprocessed: 'Unprocessed',
        processedDate: 'Processed Date',
        first_name: 'First name',
        last_name: 'Last name',
        date_of_birth: 'Date of birth',
        email: 'Email',
        emailAddress: 'Email address',
        logIn: 'Log In',
        received: 'received on',
        mhaLinkedC1: 'View your current MassHealth/Health Connector eligibility and MassHealth enrollment information, documents and MassHealth notices.',
        mhaLinkedC2: 'Need more info?',
        mhaNotLinkedBtnContent: 'Connect to my MassHealth info',
        mhaNotLinkedC1: 'Already receiving health benefits? Tell us little more about yourself, and we will show your existing benefits.',
        mhaNotLinkedC2: 'Not receiving health benefits?',
        mhaLinkedBtnContent: 'View my health info',
        dtaLinkedC1: 'View and manage your SNAP/cash benefits, submit interim report/recertification and documents online.',
        dtaLinkedC2: 'Need more info?',
        dtaLinkedBtnContent: 'Go to DTAConnect.com',
        dtaNotLinkedC1: 'Already receiving SNAP/cash benefits? Tell us little more about yourself, and we will show your existing benefits.',
        dtaNotLinkedC2: 'Not receiving SNAP/cash benefits?',
        dtaNotLinkedBtnContent: 'DTAConnect.com',
        dayRequired: 'Date is required.',
        monthRequired: 'Month is required.',
        yearRequired: 'Year is required.',
        firstNameRequired: 'First Name is required.',
        lastNameRequired: 'Last Name is required.',
        enterValidDob: 'Please enter a valid date of birth',
        enterValidSSN: 'Please enter a valid Social Security Number',
        enterValidMhID: 'Please enter a valid MassHealth ID',
        enterMhID: 'Enter MassHealth ID',
        SSNRequired: 'SSN is required.',
        MHIDRequired: 'MHID is required.',
        invalidMHID: 'Invalid MHID.',
        dob: 'DOB',
        invalidDOB: 'Please enter a valid date of birth'
      }
  }
}

export function recentActivity7days (lang, count, documentRecentDays) {
  switch (lang) {
    case EN:
      return `We've received ${count} document(s) in the last ${documentRecentDays} days. - `
    case ES:
      return `Recibimos ${count} documento(s) en los últimos ${documentRecentDays} días. - `
    case PT:
      return `Recebemos ${count} documento(s) nos últimos ${documentRecentDays} dias. - `
    case ZH:
      return `内收到 ${count} 份文件我們在過去 ${documentRecentDays} 天。 - `
    case VI:
      return `Chúng tôi đã nhận được ${count} tài liệu trong ${documentRecentDays} ngày qua. - `
    case HI:
      return `Nou resevwa  ${count} dokiman, Nan dènye ${documentRecentDays} jou yo. - `
    default:
      return `We've received ${count} document(s) in the last ${documentRecentDays} days. - `
  }
}
